import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { Link, useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import { REQUIRED_STRING } from '../../../../constants/HookForm';
import BTextField from '../../../../components/inputs/forms/BTextField';
import {
  setValues,
  onChangeForBComponents,
  onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers,
} from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useHistoryForms from '../../../../hooks/useHistoryForms';
import BHistoryNavigator from '../../../../components/BHistoryNavigator';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  customInputFormControl: {
    width: '100%',
  },
  formLabel: {
    fontSize: 16,
    marginBottom: 10,
  },
}));
const initialArea = {
  title: '',
  status: true,
};

const AreasPage = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { staticContext, ...rest } = props;
  const { globalState, saveItem } = useContext(DashboardPanelContext);

  const { viewReadOnly } = globalState;
  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue, register } = useForm();

  const {
    fetchData,
    prevHistory,
    nextHistory,
    HistoryId,
    historyIdList,
    historyStep,
    history: fetchedHistory,
    historyInfo,
  } = useHistoryForms({
    location: props.location,
    route: '/order-management/areas',
  });

  const {
    id,
    item: currentArea,
    setItem: setCurrentArea,
  } = useBasicInformationMountedEffect({
    match: props.match,
    historyIdList,
    fetchItemURL: '/areas',
    localStorageKey: 'areas',
    initialItem: initialArea,
    fetchData,
    historyId: HistoryId,
  });

  useEffect(() => {
    if (!viewReadOnly) {
      register(
        { name: 'title' },
        {
          required: REQUIRED_STRING,
        },
      );
    }
  }, []);

  useEffect(() => {
    if (currentArea.data) {
      setCurrentArea(currentArea.data);
    }
    if (currentArea) {
      setValues(setValue, currentArea);
    }
  }, [currentArea]);

  useEffect(() => {
    if (fetchedHistory && historyIdList.length !== 0) {
      setCurrentArea(fetchedHistory);
    }
  }, [fetchedHistory]);

  const onSubmit = () => {
    setLoading(true);
    const area = { ...currentArea };
    if (currentArea.status) {
      area.status = '1';
    } else {
      area.status = '0';
    }
    saveItem('areas', area, id)
      .then(() => history.push('/order-management/areas'))
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentArea, setCurrentArea);
  };

  return (
    <div className={classes.root} style={{ margin: 10 }}>
      {currentArea && (
        <Card {...rest} className={clsx(classes.root)}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/order-management/areas',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'right', marginTop: '10px', marginRight: '10px' }}
          >
            <ArrowBackIcon />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='Area Information' />
            <Divider />
            <CardContent>
              <br />
              {historyInfo}
              <Grid container spacing={3}>
                <BTextField
                  label='Title'
                  name='title'
                  value={currentArea?.title}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers}
                  error={errors.title}
                  required
                />
                <BCheckBoxField
                  sm={12}
                  name='status'
                  label='Enabled Status'
                  value={Number(currentArea?.status)}
                  error={errors.status}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitEmployee' label='Save Area' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/order-management/areas',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  Back to Area list
                </Button>
              </Grid>
            </CardActions>
          </form>
          <BHistoryNavigator
            historyStep={historyStep}
            historyIdList={historyIdList}
            prevHistory={prevHistory}
            nextHistory={nextHistory}
          />
        </Card>
      )}
    </div>
  );
};

AreasPage.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default AreasPage;
